'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLIS_PROPERTY_CONTEXT = undefined;

var _cssjanus = require('cssjanus');

var _cssjanus2 = _interopRequireDefault(_cssjanus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/thysultan/stylis.js#plugins
var STYLIS_CONTEXTS = {
  POST_PROCESS: -2,
  PREPARATION: -1,
  NEWLINE: 0,
  PROPERTY: 1,
  SELECTOR_BLOCK: 2,
  AT_RULE: 3
};

var STYLIS_PROPERTY_CONTEXT = exports.STYLIS_PROPERTY_CONTEXT = STYLIS_CONTEXTS.PROPERTY;

exports.default = function (context, content) {
  if (context === STYLIS_PROPERTY_CONTEXT) {
    return _cssjanus2.default.transform(content);
  }
};